import posthog from 'posthog-js';

// Client-side product analytics via posthog-js.
//
// HARD RAIL (card 4q7DrFjT): the key is referenced ONLY by env-var name
// (VITE_PUBLIC_POSTHOG_KEY) — never a phc_ literal in source. Everything below
// no-ops safely when the key is absent, so the SPA behaves identically with or
// without analytics configured (Vite leaves unset import.meta.env vars
// undefined at build time).
//
// NOTE: the Trello card spec said NEXT_PUBLIC_*, but this repo is a Vite SPA
// (not Next.js). Vite only exposes vars prefixed VITE_ to client code, so the
// correct convention here is VITE_PUBLIC_*.

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST = (import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string | undefined)
  ?? 'https://us.i.posthog.com';

let enabled = false;

export function initAnalytics(): void {
  if (!POSTHOG_KEY) return;
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
    });
    enabled = true;
  } catch (err) {
    console.warn('[analytics] init failed (non-fatal)', err);
  }
}

export function identifyUser(uid: string, email?: string): void {
  if (!enabled) return;
  try {
    posthog.identify(uid, email ? { email } : undefined);
  } catch (err) {
    console.warn('[analytics] identify failed (non-fatal)', err);
  }
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (!enabled) return;
  try {
    posthog.capture(event, props);
  } catch (err) {
    console.warn('[analytics] capture failed (non-fatal)', err);
  }
}
